module.exports = __webpack_public_path__ + "img/shivam.90bc95ee.png";